import React, { useState } from 'react';
import './Register.css';
import { useHistory } from "react-router-dom";
import { Link } from 'react-router-dom';
import { auth, db, storage } from '../Auth/FirebaseConfig';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import ProgressBar from 'react-bootstrap/ProgressBar';
import $ from 'jquery';


 
const Register = () => {
    document.title = `Aisbook by Alif | Sign up`;
   
    const history = useHistory("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [birthday, setBirthday] = useState([]);
    const [gender, setGender] = useState('');
    const [image, setImage] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [progress, setProgress] = useState(0);

    const  addImage  = (e) => { 
        e.preventDefault();
        if (e.target.files[0]) {
            setImage(e.target.files[0]); 
        }
    }
    const  getImageUrl  = (e) => { 
        e.preventDefault();
         $('.imgBar')[0].style.display = 'flex';
        const uploadTask = storage.ref(`users/${image.name}`).put(image);
        uploadTask.on(
            "state_changed",
            (snapshot) => {const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                setProgress(progress);
            } , (error) => {
                alert(error.message);
            } , () => {
                storage.ref("users").child(image.name).getDownloadURL()
                    .then(url => {
                      setImageUrl(url);
                      $('.imgBar')[0].style.display = 'none';
                        });
                    })
         };
    const register = (e) => { 
        e.preventDefault();
            auth.createUserWithEmailAndPassword(email, password)
            .then(auth => {
                if (auth.user) {
                    auth.user.updateProfile({
                        displayName: firstName + " " + lastName,
                        photoURL: imageUrl,
                    }).then((s) => {
                        db.collection('users').doc(auth.user.displayName).set({
                            uid: auth.user.uid,
                            displayName: auth.user.displayName,
                            email: auth.user.email,
                            photoURL: imageUrl,
                            birthday,
                            gender,
                            bio: ""
                        })
                        .then((r) => {
                            history.push("/")
                        })
                    }) 
                }
             })
            };
    
    return (
        <div className="register">
        <div className="register__container px-3">
            <h2>Sign Up</h2>
            <p>It's quick and easy.</p>
            <hr />
            <form>
                <div className="row ml-2">
                    <input onChange={ e => setFirstName(e.target.value)} type="name" placeholder="First Name"/>
                    <input onChange={ e => setLastName(e.target.value)} type="name" placeholder="Last Name"/>
                </div>
                   <input onChange={(e) => setEmail(e.target.value)} className='mt-3' type="email" placeholder="Email" />
                  <input onChange={(e) => setPassword(e.target.value)} className='mt-3' type="password" placeholder="New Password"/>
        
                <h5 className="register__date">Date Of Birth &#x3f;</h5>
                <div className="row">
                    <select className="register__date2" onChange={(e) => setBirthday([...birthday, e.target.value])}>
                        <option value="Day">Day</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="26">26</option>
                        <option value="27">27</option>
                        <option value="28">28</option>
                        <option value="29">29</option>
                        <option value="30">30</option>
                        <option value="31">31</option>
                    </select>

                    <select className="register__month" onChange={(e) => setBirthday([...birthday, e.target.value])}>
                        <option value="Day">Month</option>
                        <option value="1">Jan</option>
                        <option value="2">Feb</option>
                        <option value="3">Mar</option>
                        <option value="4">Apr</option>
                        <option value="5">May</option>
                        <option value="6">Jun</option>
                        <option value="7">Jul</option>
                        <option value="8">Aug</option>
                        <option value="9">Sep</option>
                        <option value="10">Oct</option>
                        <option value="11">Nov</option>
                        <option value="12">Dec</option>
                    </select>

                    <select className="register__year" onChange={(e) => setBirthday([...birthday, e.target.value])}>
                        <option value="2021">2021</option>
                        <option value="2020">2020</option>
                        <option value="2019">2019</option>
                        <option value="2018">2018</option>
                        <option value="2017">2017</option>
                        <option value="2016">2016</option>
                        <option value="2015">2015</option>
                        <option value="2014">2014</option>
                        <option value="2013">2013</option>
                        <option value="2012">2012</option>
                        <option value="2011">2011</option>
                        <option value="2010">2010</option>
                        <option value="2009">2009</option>
                        <option value="2008">2008</option>
                        <option value="2007">2007</option>
                        <option value="2006">2006</option>
                        <option value="2005">2005</option>
                        <option value="2004">2004</option>
                        <option value="2003">2003</option>
                        <option value="2002">2002</option>
                        <option value="2001">2001</option>
                        <option value="2000">2000</option>
                        <option value="1999">1999</option>
                        <option value="1998">1998</option>
                        <option value="1997">1997</option>
                        <option value="1996">1996</option>
                        <option value="1995">1995</option>
                        <option value="1994">1994</option>
                        <option value="1993">1993</option>
                        <option value="1992">1992</option>
                        <option value="1991">1991</option>
                        <option value="1990">1990</option>
                        <option value="1989">1989</option>
                        <option value="1988">1988</option>
                        <option value="1987">1987</option>
                        <option value="1986">1986</option>
                        <option value="1985">1985</option>
                        <option value="1984">1984</option>
                        <option value="1983">1983</option>
                        <option value="1982">1982</option>
                        <option value="1981">1981</option>
                        <option value="1980">1980</option>
                        <option value="1979">1979</option>
                        <option value="1978">1978</option>
                        <option value="1977">1977</option>
                        <option value="1976">1976</option>
                        <option value="1975">1975</option>
                        <option value="1974">1974</option>
                        <option value="1973">1973</option>
                        <option value="1972">1972</option>
                        <option value="1971">1971</option>
                        <option value="1970">1970</option>
                    </select>
                </div>

                <h5 className="register__gender">Gender &#x3f;</h5>
                <div className="register__radiocontainer">
                    <div className="wrapper">
                        <label htmlFor="female">Female</label>
                        <input onChange={(e) => setGender(e.target.value)} type="radio" name="gender" value="Female" id='female'/>
                    </div>
                    <div className="wrapper">
                        <label htmlFor="male">Male</label>
                        <input onChange={(e) => setGender(e.target.value)} type="radio" name="gender" value="Male" id='male'/>
                    </div>
                    <div className="wrapper">
                        <label htmlFor="other">Other</label>
                        <input onChange={(e) => setGender(e.target.value)} type="radio" name="gender" value="Other" id='other'/>
                    </div>
                </div>
                <ProgressBar variant="info" now={progress} className="mb-2 imgBar"/>
                <p className="register__policy">
                        By clicking Sign Up, you agree to our
                    <span> Terms, Data Policy</span> and <span>Cookie Policy</span>. You
                        may receive SMS notifications from us and can opt out at any time.
                 </p>

                <div className="d-flex">
                <label htmlFor="addPhoto" className="addImage d-flex">
                    <PhotoLibraryIcon style={{fontSize:'30px'}} className="addImageIcon"/>
                    <button className="addImageBtn" onClick={getImageUrl}>Add Profile Photo</button>
                </label>
                <input type="file" id="addPhoto" accept="image/*" onChange={addImage}/>
                   <button onClick={register} type="submit" className="register__btn">
                       Sign Up
                  </button>
                </div>
                <Link to="/login">
                    <p className="register__login">Already have an account?</p>
                </Link>
            </form>
           </div>
        </div>
    );
};

export default Register;